var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookColor = function SvgFacebookColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 .5C5.373.5 0 5.873 0 12.5s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12Zm1.25 12.527v6.529h-2.7v-6.529H9.2v-2.25h1.35v-1.35c0-1.836.762-2.927 2.927-2.927h1.802v2.25h-1.127c-.842 0-.898.314-.898.901l-.003 1.126h2.04l-.238 2.25h-1.802Z",
    fill: "#4D7579"
  })));
};
export default SvgFacebookColor;